function checkElementReady(selector, callback) {
  const interval = setInterval(function () {
    const element = document.querySelector(selector)
    if (element) {
      clearInterval(interval)
      callback(element)
    }
  }, 1000)
}

document.addEventListener('DOMContentLoaded', function () {
  checkElementReady(
    '.footer__newsletter .klaviyo-form input[type=email]',
    function (element) {
      element.addEventListener('mousedown', (e) => {
        e.target.setAttribute('mousedown', true)
        e.target.setAttribute('focused', false)
        const focusedAttribute = e.target.getAttribute('mousedown')
      })

      element.addEventListener('focusin', (e) => {
        const focusedAttribute = e.target.getAttribute('mousedown')
        if (focusedAttribute != 'true') {
          e.target.setAttribute('focused', true)
        } else {
          e.target.setAttribute('focused', false)
        }
      })

      element.addEventListener('focusout', (e) => {
        e.target.setAttribute('focused', false)
        e.target.setAttribute('mousedown', false)
      })
    }
  )
})

Shopify.addListener(document.body, 'mousedown', () => {
  document.body.classList.add('focus-visible-none')
})

Shopify.addListener(document.body, 'keydown', (event) => {
  // Re-enable focus styling when Tab/Shift is pressed
  if (event.key === 'Tab' || event.key === 'Shift' || event.key === 'Enter') {
    document.body.classList.remove('focus-visible-none')
  }
})

document.querySelector('body').addEventListener('mousedown', (event) => {
  if (event.key === 'Tab' || event.key === 'Shift' || event.key === 'Enter') {
    document.querySelector('body').classList.add('focus-visible-none')
  }
})

document.querySelector('body').addEventListener('keydown', (event) => {
  if (event.key === 'Tab' || event.key === 'Shift' || event.key === 'Enter') {
    document.querySelector('body').classList.remove('focus-visible-none')
  }
})
